// 质检总览
<template>
    <div class="menu">
        <div class="screening">
            <el-collapse v-model="activeNames" @change="handleChange">
                <el-collapse-item title="统计栏" name="1">
                    <div class="out-box">
                        <el-row :gutter="30">
                            <el-col :span="6">
                                <div class="statistical-son-box bg-color1">
                                    <div class="count-box">
                                        <div>
                                            <div class="font-color title1">
                                                <icon-font type="icon-cishu_data-sheet-01" class="font-size4"/>
                                                质检费用
                                            </div>
                                            <div class="font-color font-size1">
                                                <span class="font-size9">￥</span>
                                                {{ countList?.checkCharge == null?'0':countList?.checkCharge }}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </el-col>
                            <el-col :span="6">
                                <div class="statistical-son-box bg-color2">
                                    <div class="count-box">
                                        <div>
                                            <div class="font-color title1">
                                                <icon-font type="icon-cishu_data-sheet-05" class="font-size6"/>
                                                命中规则次数
                                            </div>
                                            <div class="font-color font-size5">
                                                {{ countList?.hitRuleCount == null?'0':countList?.hitRuleCount }}
                                                <span class="font-size9">次</span>
                                            </div>
                                            <div>
                                                <span class="font-color">命中分类次数</span>
                                                <span class="font-color font-size2">
                                                    {{ countList?.hitTypeCount == null?'0':countList?.hitTypeCount }}
                                                    <span class="font-size9">次</span>
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </el-col>
                            <el-col :span="6">
                                <div class="statistical-son-box bg-color3">
                                    <div class="count-box">
                                        <div>
                                            <div class="font-color title1">
                                                <icon-font type="icon-cishu_data-sheet-03" class="font-size4"/>
                                                质检分钟数
                                            </div>
                                            <div class="font-color font-size1">
                                                {{ countList?.minutesCount == null?'0':countList?.minutesCount }}
                                                <span class="font-size9">min</span>
                                            </div>
                                            <div>
                                                <span class="font-color">质检次数</span>
                                                <span class="font-color font-size2">
                                                    {{ countList?.checkTotal == null?'0':countList?.checkTotal }}
                                                    <span class="font-size9">次</span>
                                                </span>
                                            </div>
                                            <div>
                                                <span class="font-color">质检成功数</span>
                                                <span class="font-color font-size3">
                                                    {{ countList?.checkSuccess == null?'0':countList?.checkSuccess }}
                                                    <span class="font-size9">次</span>
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </el-col>
                            <el-col :span="6">
                                <div class="statistical-son-box bg-color4">
                                    <div class="count-box">
                                        <div>
                                            <div class="font-color title1">
                                                <icon-font type="icon-cishu_data-sheet-04" class="font-size4"/>
                                                识别分钟数
                                            </div>
                                            <div class="font-color font-size1">
                                                {{ countList?.recognitionMinutes == null?'0':countList?.recognitionMinutes }}
                                                <span class="font-size9">min</span>
                                            </div>
                                            <div>
                                                <span class="font-color">识别次数</span>
                                                <span class="font-color font-size2">
                                                    {{ countList?.recognitionTotal == null?'0':countList?.recognitionTotal }}
                                                    <span class="font-size9">次</span>
                                                </span>
                                            </div>
                                            <div>
                                                <span class="font-color">识别成功数</span>
                                                <span class="font-color font-size3">
                                                    {{ countList?.recognitionSuccess == null?'0':countList?.recognitionSuccess }}
                                                    <span class="font-size9">次</span>
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </el-col>
                        </el-row>
                    </div>
                </el-collapse-item>
                <el-collapse-item title="筛选栏" name="2">
                    <div class="screening-out">
                        <el-form :inline="true" class="demo-form-inline">
                            <el-row>
                                <el-col :span="6">
                                    <el-form-item label="昵称">
                                        <el-input v-model="searchFrom.nickname" placeholder="请输入需要查询的昵称" size="mini"></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label="查询时间段">
                                        <el-date-picker
                                            v-model="valueTime"
                                            type="daterange"
                                            value-format="YYYY-MM-DD"
                                            start-placeholder="开始日期"
                                            end-placeholder="结束日期"
                                            :default-time="defaultTime"
                                            size="mini"
                                        >
                                        </el-date-picker>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="6">
                                    <!-- <el-form-item> -->
                                        <div class="title-buttom">
                                            <el-button class="cancel" size="small" @click="reset" round>重置</el-button>
                                            <el-button type="primary" size="small" class="confirmAdd" @click="onSubmit" round>查询</el-button>
                                        </div>
                                    <!-- </el-form-item> -->
                                </el-col>
                            </el-row>
                        </el-form>
                    </div>
                </el-collapse-item>
            </el-collapse>
        </div>
        <el-row>
            <el-col :span="12">
                <div class="title-name">
                    数据列表
                </div>
            </el-col>
            <el-col :span="12">
                <div class="title-buttom">
                    <el-tooltip content="刷新列表" placement="top" effect="light">
                        <el-button class="editor" size="mini" icon="el-icon-refresh-right" @click="getDataList(true)" circle></el-button>
                    </el-tooltip>
                    <!-- <el-button class="deletetable" size="mini" icon="el-icon-delete" @click="deleteData" round>删除</el-button> -->
                </div>
            </el-col>
        </el-row>
        <el-row>
            <el-col :span="24">
                <div>
                   <el-table
                    class="eltable"
                    v-loading="loading"
                    ref="multipleTable"
                    :data="tableData"
                    tooltip-effect="dark"
                    style="width: 100%"
                    :header-cell-style="{background:'#e0e5ff',color:'#24252F'}"
                    row-key="id"
                    :max-height="tableHeight"
                    default-expand-all
                    :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
                    @selection-change="handleSelectionChange">
                        <!-- <el-table-column
                        type="selection"
                        width="55">
                        </el-table-column> -->
                        <el-table-column
                        label="昵称">
                        <template #default="scope">{{ scope.row.nickname == null|| scope.row.nickname == ''?'-': scope.row.nickname}}</template>
                        </el-table-column>
                        <el-table-column
                        label="质检次数">
                        <template #default="scope">{{ scope.row.checkTotal == null|| scope.row.checkTotal == ''?'-': scope.row.checkTotal}}次</template>
                        </el-table-column>
                        <el-table-column
                        label="质检成功数">
                        <template #default="scope">{{ scope.row.checkSuccess == null|| scope.row.checkSuccess == ''?'-': scope.row.checkSuccess}}次</template>
                        </el-table-column>
                        <el-table-column
                        label="质检费用">
                        <template #default="scope">{{ scope.row.checkCharge == null|| scope.row.checkCharge ==
                        ''?'-': scope.row.checkCharge.toFixed(3)}}元</template>
                        </el-table-column>
                        <el-table-column
                        label="质检分钟数">
                        <template #default="scope">{{ scope.row.minutesCount == null|| scope.row.minutesCount == ''?'-': scope.row.minutesCount}}min</template>
                        </el-table-column>
                        <el-table-column
                        label="命中分类次数">
                        <template #default="scope">{{ scope.row.hitTypeCount == null|| scope.row.hitTypeCount == ''?'-': scope.row.hitTypeCount}}次</template>
                        </el-table-column>
                        <el-table-column
                        label="识别次数">
                        <template #default="scope">{{ scope.row.recognitionTotal == null|| scope.row.recognitionTotal == ''?'-': scope.row.recognitionTotal}}</template>
                        </el-table-column>
                        <el-table-column
                        label="识别成功数">
                        <template #default="scope">{{ scope.row.recognitionSuccess == null|| scope.row.recognitionSuccess == ''?'-': scope.row.recognitionSuccess}}</template>
                        </el-table-column>
                        <el-table-column
                        label="识别小时数">
                        <template #default="scope">{{ scope.row.recognitionMinutes ==
                        null||scope.row.recognitionMinutes == ''?'-': (scope.row.recognitionMinutes/3600)
                            .toFixed(2)}}</template>
                        </el-table-column>
                        <el-table-column
                        label="日期">
                        <template #default="scope">{{ scope.row.date == null|| scope.row.date == ''?'-': scope.row.date}}</template>
                        </el-table-column>
                    </el-table>
                </div>
            </el-col>
        </el-row>
        <div class="pager">
            <div>
                <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                background
                :page-sizes="[10, 20, 30, 40]"
                :page-size="searchFrom.pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total">
                </el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
import voiceCount from '@/api/open/voiceCount/voiceCount'
import { IconFont } from "@/utils/iconfont"
export default {
    components: {
        IconFont,
    },
    data () {
        return {
            tableHeight:'',
            searchFrom:{
                page:1,
                pageSize:10,
                nickname:'',
                dateBegin:'',
                dateEnd:''
            },
            total:0,
            currentPage: 1,//分页
            multipleSelection: [],//选中集合
            valueTime:'',//选中时间段
            defaultTime: [
                new Date(2000, 1, 1, 12, 0, 0),
                new Date(2000, 2, 1, 8, 0, 0)
            ], //默认时间 '12:00:00', '08:00:00'
            activeNames: [],//折叠面板
            tableData: [],//菜单表
            // loding 状态启用
            loading: true,
            totalList:{},
            countList:{},
        }
    },
    created() {
        this.tableHeight = this.$store.state.tableHeight
    },
    watch: {

    },
    mounted() {
        this.getDataList(true)
    },
    methods: {
        // 查询
        onSubmit() {
            this.searchFrom.dateBegin = this.valueTime[0]
            this.searchFrom.dateEnd = this.valueTime[1]
            this.getDataList(true)
        },
        // 重置
        reset() {
            this.searchFrom = {
                page: this.currentPage,
                pageSize: 10,
                nickname:'',
                dateBegin:'',
                dateEnd:''
            },
            this.valueTime = []
            this.getDataList(true)
        },
        // 获取数据列表
        getDataList(type) {
            this.loading = type
            console.log(this.valueTime)
            voiceCount.count({
                dateBegin : this.valueTime == []?'':this.valueTime[0],
                dateEnd : this.valueTime == []?'':this.valueTime[1]
            }).then((res) => {
                this.countList = res.data
            })
            voiceCount.list({
                ...this.searchFrom
            }).then((res) => {
                this.tableData = res.data.records
                this.total = res.data.total
                this.loading = false
            })
        },
        // 分页
        handleSizeChange(val) {
            // console.log(`每页 ${val} 条`);
            this.searchFrom.pageSize = val
            this.getDataList(true)
        },
        handleCurrentChange(val) {
            // console.log(`当前页: ${val}`);
            this.searchFrom.page = val
            this.currentPage =val
            this.getDataList(true)
        },
        // 折叠面板
        handleChange(val) {
            console.log(val);
        },
        // 多选
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        // 批量删除
        deleteData() {
            console.log(this.multipleSelection)
        },
    }
}
</script>

<style lang="scss" scoped>
.menu{
    height: 100%;
    overflow-y: overlay;
    padding-right: 1.125rem;
    .title-name{
        font-size: .9375rem;
        font-weight: 600;
        color: #303133;
    }
    .top-first{
        .search-box{
            width: 18.75rem;
        }
    }
}
.screening{
    margin-bottom: .9375rem;
}
.el-row {
    margin-bottom: .9375rem;
    &:last-child {
        margin-bottom: 0;
    }
}
.out-box{
    padding: .8rem;
}
.title-buttom{
    display: flex;
    flex-wrap: nowrap;
    justify-content: flex-end;
    align-items: center;
}
.editor{
    color: #0170ED;
    background: #E3F0FF;
}
.center-body{
    margin: 0 1.875rem;
}
.deletetable{
    color: #FF845B;
    background: #FFE4DB;
}
.deletetable-other{
    margin-right: 1.25rem;
}
.confirmAdd{
    background: #637DFF;
    color: #fff;
}
.cancel{
    color: #637DFF;
    border: #637DFF solid 1px;
}
.screening-out{
    margin: 0 .9375rem;
}
.out-icon:hover{
    background: #E3F0FF;
    color: #0170ED;
}
.pager {
    display: flex;
    justify-content: flex-end;
}
.statistical-box{
    display: flex;
    flex-wrap: nowrap;
    justify-content: space-between;
    align-items: center;
    margin: 1.5rem;
}
.statistical-son-box{
    border-radius: .666rem;
    padding: .8rem 0;
    box-shadow: 0px 0px 6px 0px #d3d6e2; 
    // padding: 1rem 3.5rem;
    display: flex;
    flex-wrap: nowrap;
    justify-content: center;
    align-items: center;
}
.title1{
    font-size: 1.4rem;
    display: flex;
    align-items: center;
}
.font-size1{
    text-indent: .5rem;
    color: #637DFF;
    font-weight: 700;
    font-size: 2rem;
}
.font-size2{
    display: inline-block;
    text-align: right;
    width: 5rem;
    font-size: 1rem;
    margin-left: .666rem;
}
.font-size3{
    display: inline-block;
    text-align: right;
    width: 5rem;
    font-size: 1.375rem;
    margin-left: .666rem;
}
.font-size4{
    color: #637DFF;
    margin-right: .5rem;
    font-size: 2rem;
}
.font-size5{
    text-indent: .5rem;
    color: #FF694A;
    font-weight: 700;
    font-size: 2rem;
}
.font-size6{
    color: #FF694A;
    margin-right: .5rem;
    font-size: 2rem;
}
.font-size7{
    color: #FCA603;
    margin-right: .5rem;
    font-size: 2rem;
}
.font-size8{
    text-indent: .5rem;
    color: #FCA603;
    font-weight: 700;
    font-size: 2rem;
}
.font-size9{
    font-size: 1rem;
}
.img-icon{
    font-size: .75rem;
    color: #637DFF;
}
.count-box{
    height: 10.625rem;
    display: flex;
    flex-wrap: nowrap;
    justify-content: center;
    align-items: center;
}
// .bg-color1{
//     background: linear-gradient(90deg, #8de0e9, #37d6e7);;
// }
// .bg-color2{
//     background: linear-gradient(90deg, #e98888, #e53d3d);;
// }
// .bg-color3{
//     background: linear-gradient(90deg, #bc4beb, #814beb);;
// }
// .bg-color4{
//     background: linear-gradient(90deg, #4d4beb, #4b7ceb);;
// }
// .bg-color5{
//     background: linear-gradient(90deg, #97eb4b, #e9eb4b);;
// }
</style>

<style lang="scss">
.menu .el-collapse-item__content {
    padding-bottom: 0 !important;
}
.eltable {
    overflow-y: overlay;
}
</style>